<app-auth-header></app-auth-header>

<div
  class="relative h-[100%] bg-cover bg-center text-white flex items-center justify-center"
  style="background-image: url('assets/images/home_bg_img.png')"
>
  <div class="absolute inset-0 !bg-[#272c36] !bg-opacity-60"></div>

  <div
    class="fixed z-10 flex justify-center !w-[65vw] mt-[4vh] !max-h-[95.5vh] bg-[#F1F3F5] rounded-[8px] overflow-auto org-detail"
  >
    <mat-icon
      class="text-black !mt-[25px] ml-[35px] cursor-pointer"
      (click)="navigateTo()"
      >keyboard_arrow_left</mat-icon
    >
    <div class="mt-[1rem] ml-[1rem] mr-[5rem] mb-[2.81rem] w-[100%]">
      <div class="flex justify-center"></div>

      <h4 class="text-[#21252A] !text-[1.5rem] !font-semibold">
        Organization Details
      </h4>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="flex justify-between">
          <div>
            <div class="mt-[0.5rem] \">
              <!-- Org name -->
              <div class="flex items-center justify-between">
                <mat-form-field class="w-[24.4vw]" appearance="outline">
                  <mat-label>Enter Your Organization Name</mat-label>
                  <input
                    matInput
                    id="org_name"
                    formControlName="org_name"
                    placeholder="Enter Your Organization Name"
                    class="w-full bg-[#F1F3F5] text-[#21252A] border-[1px] border-[#1A4971] pl-[23px] h-[44px] rounded-[10px] py-[10px] flex-shrink-0"
                  />
                  <mat-error
                    *ngIf="
                      form.get('org_name')?.touched &&
                      form.get('org_name')?.invalid
                    "
                  >
                    <span *ngIf="form.get('org_name')?.errors?.['required']">
                      Organization Name is required
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
              <!-- org designation -->
              <div class="flex items-center justify-between !mt-[10px]">
                <mat-form-field appearance="outline" class="w-[24.4vw]">
                  <mat-label>Title/Designation</mat-label>
                  <input
                    matInput
                    id="org_designation"
                    formControlName="org_designation"
                    type="text"
                    placeholder="Enter Your Title/Designation"
                    class="bg-[#F1F3F5] text-[#21252A] h-[44px] rounded-[10px]"
                  />
                  <mat-error
                    *ngIf="
                      form.get('org_designation')?.touched &&
                      form.get('org_designation')?.invalid
                    "
                  >
                    <span
                      *ngIf="form.get('org_designation')?.errors?.['required']"
                    >
                      Title/Designation is required
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
              <!-- country -->
              <div class="rounded w-[24.4vw] !mt-[10px]">
                <app-country 
                [country]="countryFromMap"
                (changeCountry)="updateCountry($event)"
                >
              </app-country>
              </div>
              <!-- Org Type -->
              <div class="flex items-center justify-between !mt-[10px]">
                <mat-form-field appearance="outline" class="w-[24.4vw]">
                  <mat-label>Organization Type</mat-label>
                  <mat-select
                    id="org_type"
                    formControlName="org_type"
                    class=" text-[#21252A] rounded-[10px]"
                  >
                    <mat-option
                      *ngFor="let type of organizationTypes"
                      [value]="type.value"
                    >
                      {{ type.label }}
                    </mat-option>
                  </mat-select>

                  <mat-error
                    *ngIf="
                      form.get('org_type')?.touched &&
                      form.get('org_type')?.invalid
                    "
                  >
                    <span *ngIf="form.get('org_type')?.errors?.['required']">
                      Organization type is required
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- oragnization Email -->
              <div class="flex items-center justify-between !mt-[10px]">
                <mat-form-field appearance="outline" class="w-[24.4vw]">
                  <mat-label>Organization Email</mat-label>
                  <input
                    matInput
                    id="org_email"
                    formControlName="org_email"
                    type="text"
                    placeholder="Enter Your Organization Email"
                    class="bg-[#F1F3F5] text-[#21252A] h-[44px] rounded-[10px]"
                  />
                  <mat-error
                    *ngIf="
                      form.get('org_email')?.touched &&
                      form.get('org_email')?.invalid
                    "
                  >
                    <span *ngIf="form.get('org_email')?.errors?.['required']">
                      Organization Email is required
                    </span>
                    <span
                      *ngIf="form.get('org_email')?.errors?.['emailExists']"
                    >
                      This email is already in use
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- oragnization Phone # -->
              <div class="flex items-center justify-between !mt-[10px] !mb-0">
                <mat-form-field appearance="outline" class="w-[24.4vw]">
                  <mat-label>Contact Number</mat-label>
                  <input
                    matInput
                    id="phonenumber"
                    formControlName="phonenumber"
                    type="text"
                    placeholder="Enter Your Contact Number"
                    class="bg-[#F1F3F5] text-[#21252A] h-[44px] rounded-[10px]"
                  />
                  <mat-error
                    *ngIf="
                      form.get('phonenumber')?.touched &&
                      form.get('phonenumber')?.invalid
                    "
                  >
                    <span *ngIf="form.get('phonenumber')?.errors?.['required']">
                      Contact number is required
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
              <!-- Password -->
              <div class="flex items-center justify-between !mt-[10px]">
                <mat-form-field appearance="outline" class="w-[24.4vw]">
                  <mat-label>Password</mat-label>
                  <input
                    matInput
                    id="password"
                    formControlName="password"
                    [type]="viewPassword ? 'text' : 'password'"
                    placeholder="Enter Your Password"
                    class="bg-[#F1F3F5] text-[#21252A] h-[44px] rounded-[10px]"
                  />
                  <mat-icon
                    matSuffix
                    class="text-[#FF6F00] !text-[20px]"
                    (click)="viewPassword = !viewPassword"
                    >{{
                      viewPassword ? "visibility" : "visibility_off"
                    }}</mat-icon
                  >
                  <mat-error
                    *ngIf="
                      form.get('password')?.touched &&
                      form.get('password')?.invalid
                    "
                  >
                    <span *ngIf="form.get('password')?.errors?.['required']">
                      Password is required
                    </span>
                    <span *ngIf="form.get('password')?.errors?.['minlength']">
                      Password must be at least 8 characters long
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Confirm Password -->
              <div class="flex items-center justify-between !mt-[10px]">
                <mat-form-field appearance="outline" class="w-[24.4vw]">
                  <mat-label>Confirm Password</mat-label>
                  <input
                    matInput
                    id="confirmPassword"
                    formControlName="confirmPassword"
                    [type]="viewPassword ? 'text' : 'password'"
                    placeholder="Enter Your Confirm Password"
                    class="bg-[#F1F3F5] text-[#21252A] h-[44px] rounded-[10px]"
                  />

                  <mat-error
                    *ngIf="
                      form.get('confirmPassword')?.touched &&
                      form.get('confirmPassword')?.invalid
                    "
                  >
                    <span
                      *ngIf="form.get('confirmPassword')?.errors?.['required']"
                    >
                      Confirm Password is required
                    </span>
                    <span
                      *ngIf="form.get('confirmPassword')?.errors?.['minlength']"
                    >
                      Password must be at least 8 characters long
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="flex flex-col justify-between">
            <div class="flex justify-end bottom-0">
              <div>
                <!-- Logo Display -->
                <div
                  class="w-[207px] flex justify-center items-center cursor-pointer"
                  style="
                    border: 2px solid rgba(32, 61, 84, 0.2);
                    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
                  "
                  (click)="uploadLogo()"
                >
                  <!-- Show uploaded image or default -->
                  <img
                    [src]="
                      form.get('logoPreview')?.value ||
                      'assets/icons/org_logo_icon.svg'
                    "
                    alt="org logo"
                    class="w-full h-full object-contain"
                  />
                </div>

                <!-- Organization Logo Text -->
                <div class="text-center mt-[8px] w-[207px]">
                  <span
                    class="text-[#21252A] font-roboto text-xl font-bold leading-[120%] tracking-[-0.045rem]"
                    >Organization Logo</span
                  >
                </div>
              </div>

              <!-- Hidden File Input -->
              <input
                type="file"
                accept="image/*"
                #fileInput
                (change)="onFileSelected($event)"
                style="display: none"
              />
            </div>
          </div>
        </div>
        <div class="text-black static align-bottom flex justify-end mb-5">
          <div class="flex">
            <button
              (click)="login()"
              class="flex w-[114px] h-[48px] justify-center items-center flex-shrink-0 bg-[#F1F3F5] border-[2px] border-[#E76B3F] rounded-[0.3125rem] text-[#E76B3F] font-semibold text-[16px] ml-[2px] cursor-pointer"
              style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
            >
              Back
            </button>

            <div class="hidden" id="recaptcha-container"></div>
            <button
              type="submit"
              class="flex bg-[#E76B3F] text-[#F1F3F5] w-[114px] h-[48px] justify-center items-center flex-shrink-0 rounded-[0.3125rem] font-semibold text-[1rem] cursor-pointer ml-[10px]"
              style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
            >
              Next
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
